export const Checkbox_List = `
<h3>Checkbox List</h3>
<hr />
<article id="checkbox-list">
   <div class="row">
      <div class="col-lg-3 d-none d-lg-block"></div>
      <div class="col-lg-7 col-md-12">
         <div class="copy intro">As someone with ENFJ preferences, you may find that the following actions or behaviors drain your confidence. Tick any you recognize!</div>
         <div class="checkbox-list">
            <div class="checkbox-container" id="checkbox1-container">
               <input type="checkbox" id="checkbox1">
               <label for="checkbox1" class="checkbox-label" id="checkbox1-label">Receiving insufficient feedback on and appreciation for your contribution</label>
            </div>
            <div class="checkbox-container" id="checkbox2-container">
               <input type="checkbox" id="checkbox2">
               <label for="checkbox2" class="checkbox-label" id="checkbox2-label">Working in a competitive environment that lacks harmony</label>
            </div>
            <div class="checkbox-container" id="checkbox3-container">
               <input type="checkbox" id="checkbox3">
               <label for="checkbox3" class="checkbox-label" id="checkbox3-label">Finding flaws in others’ ideas and correcting them</label>
            </div>
            <div class="checkbox-container" id="checkbox4-container">
               <input type="checkbox" id="checkbox4">
               <label for="checkbox4" class="checkbox-label" id="checkbox4-label">Working in a situation where expectations and outcomes are unclear</label>
            </div>
            <div class="checkbox-container" id="checkbox5-container">
               <input type="checkbox" id="checkbox5">
               <label for="checkbox5" class="checkbox-label" id="checkbox5-label"></label>
            </div>
            <div class="checkbox-container" id="checkbox6-container">
               <input type="checkbox" id="checkbox6">
               <label for="checkbox6" class="checkbox-label" id="checkbox6-label"></label>
            </div>
            <div class="checkbox-container" id="checkbox7-container">
               <input type="checkbox" id="checkbox4">
               <label for="checkbox7" class="checkbox-label" id="checkbox7-label"></label>
            </div>
            <div class="checkbox-container" id="checkbox8-container">
               <input type="checkbox" id="checkbox4">
               <label for="checkbox8" class="checkbox-label" id="checkbox8-label"></label>
            </div>
            <div class="checkbox-container" id="checkbox9-container">
               <input type="checkbox" id="checkbox4">
               <label for="checkbox9" class="checkbox-label" id="checkbox9-label"></label>
            </div>
            <div class="checkbox-container" id="checkbox10-container">
               <input type="checkbox" id="checkbox4">
               <label for="checkbox10" class="checkbox-label" id="checkbox10-label"></label>
            </div>
         </div>
         <div class="copy outro">Let’s take a look at some possible behaviors that could be causing your irritation.</div>
      </div>
      <div class="col-lg-2 d-none d-lg-block"></div>
   </div>
</article>
`;
